
<div class="Customers customers-points ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'customers.points' | translate }}</h1>
  </div>
  <div class="ui-g-12 ui-lg-12">
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

    <div class="ui-g-12">
      <kv-search-toolbar
        [dateBoxEnabled]="true"
        [date_structure]="searchModel.date_structure"
        [card_modes]="searchModel.card_modes"
        [clusters]="searchModel.cluster_list"
        [customersBoxEnabled]="false"
        [clusterFieldEnabled]="false"
        [selectedElapsedStart]="searchModel.selectedStartDate"
        [selectedElapsedEnd]="searchModel.selectedEndDate"
        [group_types]="searchModel.group_types"
        [groups]="searchModel.groups"
        [areas]="searchModel.areas"
        [stores]="searchModel.stores"
        [disableMutualExclusivity]="false"
        (onDateStructureSelectionChange)="dateStructureSelectionChange($event)"
        appQFilter
        (onQFilter)="performFilter($event)"
      ></kv-search-toolbar>
    </div>

    <div class="overview-container card ui-g-nopad">
       <app-customer-points-cumulated [hidden]="activeIndex !== 0"></app-customer-points-cumulated>
      <app-customer-points-redemption [hidden]="activeIndex !== 1" #redemptionPoints> </app-customer-points-redemption>
    </div>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-points/customers-points.component.html